import jwt from "jsonwebtoken";
import { useHistory } from "react-router";
import { toast } from "react-toastify";

function VerifyToken() {
    const loggedUserJson = window.localStorage.getItem("loggedUser") || null;
    const h = useHistory();
    const user = JSON.parse(loggedUserJson || "");
    const verify:any = jwt.decode(user)
    const {exp} = verify
    if (new Date() >= new Date(exp*1000)) {
        toast.success("Su sesión ha expirado, vuelva a iniciar sesión");
        window.localStorage.removeItem('loggedUser')
        h.push("/")
    }
}

export default VerifyToken
 